module.exports = __webpack_public_path__ + "img/thirdpartyicon.48017672.svg";